var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsPolish = function SvgMetricsPolish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.555 34.798A12.55 12.55 0 0 1 24 36.65c-6.975 0-12.649-5.675-12.649-12.649S17.025 11.35 24 11.35s12.649 5.675 12.649 12.649c0 2.401-.685 4.641-1.852 6.555l5.294 5.294L45 24 38.85 9.151 24 3 9.151 9.151 3 24l6.15 14.849L24 45l11.85-4.908z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14.849c-5.046 0-9.151 4.106-9.151 9.151s4.105 9.151 9.151 9.151 9.151-4.106 9.151-9.151-4.105-9.151-9.151-9.151"
  })))));
};
export default SvgMetricsPolish;